import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1894b268"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (ai, ak) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: ak }, [
        (ai.type === undefined || ai.type === 'button')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: ai.click,
              disabled: ai.disabled === true ? true : false
            }, {
              icon: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["iconfont", `icon-${ai.name}`])
                  }, null, 2)
                ])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(ai.label), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"]))
          : (ai.type === 'input')
            ? (_openBlock(), _createBlock(_component_a_input, {
                key: 1,
                value: ai.keyword,
                "onUpdate:value": ($event: any) => ((ai.keyword) = $event),
                "allow-clear": "",
                placeholder: ai.label,
                style: {"width":"200px"}
              }, null, 8, ["value", "onUpdate:value", "placeholder"]))
            : (ai.type === 'select')
              ? (_openBlock(), _createBlock(_component_a_select, {
                  key: 2,
                  value: ai.select,
                  "onUpdate:value": ($event: any) => ((ai.select) = $event),
                  options: ai.options,
                  "show-search": "",
                  "option-filter-prop": "label",
                  onChange: ai.change,
                  style: {"width":"200px"}
                }, null, 8, ["value", "onUpdate:value", "options", "onChange"]))
              : (ai.type === 'search')
                ? (_openBlock(), _createBlock(_component_a_input_search, {
                    key: 3,
                    value: ai.keyword,
                    "onUpdate:value": ($event: any) => ((ai.keyword) = $event),
                    "allow-clear": "",
                    placeholder: ai.label,
                    onSearch: ai.search,
                    style: {"width":"200px"}
                  }, null, 8, ["value", "onUpdate:value", "placeholder", "onSearch"]))
                : (ai.type === 'radio')
                  ? (_openBlock(), _createBlock(_component_a_radio_group, {
                      key: 4,
                      value: ai.select,
                      "onUpdate:value": ($event: any) => ((ai.select) = $event),
                      "button-style": "solid",
                      onChange: ai.change
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ai.options, (oi, ok) => {
                          return (_openBlock(), _createBlock(_component_a_radio_button, {
                            key: ok,
                            value: oi.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(oi.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "onUpdate:value", "onChange"]))
                  : (ai.type === 'dates')
                    ? (_openBlock(), _createBlock(_component_a_range_picker, {
                        key: 5,
                        value: ai.dates,
                        "onUpdate:value": ($event: any) => ((ai.dates) = $event)
                      }, null, 8, ["value", "onUpdate:value"]))
                    : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}